import React from 'react';

interface FloatingChatButtonProps {
  onClick?: () => void;
  isVisible?: boolean;
}

// Simple chat icon component
const ChatIcon: React.FC = () => (
  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  </svg>
);

// Main floating chat button component
const FloatingChatButton: React.FC<FloatingChatButtonProps> = ({ 
  onClick = () => {}, 
  isVisible = true 
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6">
      <button
        onClick={onClick}
        className="bg-brand-dark-blue dark:bg-blue-600 hover:bg-brand-electric-blue dark:hover:bg-blue-500 text-white rounded-full p-3 shadow-lg dark:shadow-xl dark:shadow-slate-900/50 transition-colors duration-200"
        aria-label="Chat support"
      >
        <ChatIcon />
      </button>
    </div>
  );
};

export default FloatingChatButton;

// Export individual components for reuse
export { ChatIcon };
